<template>
	<CreationWizardStepWrapper>
		<template #header>
			<SlackNativeSettingsHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="display-flex height-100 flex-wrap">
			<div class="flex-col-12">
				<div class="middle-section">
					<div>
						<h2>Connect your Slack workspace</h2>
						<div v-if="slackIsConnected">
							<p class="explanation mt-2">
								Your Slack workspace
								<b
									><span class="semi">{{ account.slack_integration.team_name }}</span></b
								>
								is connected
								<small
									>(connected by <b>{{ account.slack_integration?.connected_by?.first_name }}</b
									>)</small
								>
							</p>
							<br />
							<br />
						</div>
						<template v-else>
							<div>
								<PrimaryButton :disabled="!hasPermissionToChangeAccount" @click="connectSlack">Connect Slack</PrimaryButton>
								<template v-if="!hasPermissionToChangeAccount">
									<small>You must be a Ply workspace admin in order to connect Slack.</small>
									<p class="explanation mt-2">Ask one of your Ply workspace admins to connect Slack in order to add Slack features.</p>
								</template>
							</div>
						</template>
					</div>
				</div>
			</div>
			<div class="flex-1 flex-center--end pt-6">
				<PrimaryButton @click="nextStep" :disabled="!slackIsConnected" :loading="loading">Next</PrimaryButton>
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import WizardStepMixin from '../../WizardStepMixin';
import props from './SlackNativeSettings.props';
import SlackNativeSettingsHeader from './SlackNativeSettingsHeader.vue';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { account, hasAccountPermission } from '@/store/modules/account/getters';
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';
import { getActiveAccount } from '@/store/modules/account/actions';
import { SLACK_CONNECTED_EVENT, SLACK_BROADCAST_CHANNEL_NAME } from '@/views/settings/consts';
const bc = new BroadcastChannel(SLACK_BROADCAST_CHANNEL_NAME);
export default {
	name: 'SlackNativeSettings',
	mixins: [WizardStepMixin],
	props,
	components: { SlackNativeSettingsHeader },
	computed: {
		...mapGettersShorthand({
			account,
			hasAccountPermission,
		}),
		creationIsDisabled() {
			return isNullOrUndefinedOrEmpty(this.name);
		},
		hasPermissionToChangeAccount() {
			return this.hasAccountPermission(AccountPermissions.ChangeAccount);
		},
		slackIsConnected() {
			return !!this.account.slack_integration;
		},
		slackInstallUrl() {
			return `${process.env.VUE_APP_API}integrations/slack/install`;
		},
	},
	methods: {
		...mapActionsShorthand({ getActiveAccount }),
		connectSlack() {
			const height = window.screen.availHeight - 300;
			const width = window.screen.availWidth - 300;
			const topBarHeight = outerHeight - innerHeight;
			const top = screen.availTop + screen.availHeight / 2 - height / 2 - topBarHeight / 2;
			const left = screen.availLeft + screen.availWidth / 2 - width / 2;
			window.open(this.slackInstallUrl, 'Connect Slack', `height=${height},width=${width}, top=${top}, left=${left}`);
		},
		onMessage(event) {
			const data = event.data;
			if (!data) {
				return;
			}
			if (data === SLACK_CONNECTED_EVENT) {
				this.getActiveAccount();
				this.$toast.success('Slack connected successfully');
			}
		},
		removeMessageListener() {
			if (this.messageHandler) {
				window.removeEventListener('message', this.messageHandler);
				this.messageHandler = null;
			}
		},
		listenOnMessage() {
			this.removeMessageListener();
			this.messageHandler = (e) => this.onMessage(e);
			bc.addEventListener('message', this.messageHandler);
		},
	},
	data() {
		return { name: '', loading: false };
	},
	watch: {},
	mounted() {
		this.listenOnMessage();
	},
	beforeDestroy() {
		this.removeMessageListener();
	},
};
</script>

<style scoped lang="scss">
@import '@/components/CreationWizard/assets/creation-wizard-vars.scss';
.middle-section {
	h3 {
		color: $secondary-content-title-font-color;
	}
}
</style>
